import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SortEnum } from 'src/app/utils/enums/sort-enum';
import { Ccam } from 'src/app/utils/interfaces/new/ccam.interface';
import { CcamFilter } from 'src/app/utils/interfaces/new/filtre-ccam.interface';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { environment } from 'src/environments/environment';
import { FiltresService } from '../../filtres/filtres.service';
import { SnackbarService } from '../../snackbar/snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class CcamService {

  private httpOptions = {
    withCredentials: true,
    observe: 'response' as 'response',
    headers: new HttpHeaders()
  };

  private apiUri = `${environment.basePath}/facturation/ccam`;

  constructor(
    private _http: HttpClient,
    private _filtresService: FiltresService,
    private _snack: SnackbarService
  ) { }

  public async create(ccam: Ccam) {
    try {
      const res = await this._http.post(`${this.apiUri}/user/${ccam.id}`, ccam, this.httpOptions).toPromise();
      return res.body;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async findUser() {
    try {
      const res = await this._http.get(`${this.apiUri}/user`, this.httpOptions).toPromise();
      const ccam = res.body as Ccam[];
      return ccam;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async findOneUser(id: string) {
    try {
      const res = await this._http.get(`${this.apiUri}/user/${id}`, this.httpOptions).toPromise();
      const ccam = res.body as Ccam;
      return ccam;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async findHypermed(pageFiltre: Filtres = {
    perpage: -1,
    currentPage: 1,
    sortOrder: SortEnum.ASC,
    sortBy: 'code'
  }, filtres?: CcamFilter): Promise<Paginated<Ccam>> {
    try {
      this.httpOptions.headers = this._filtresService.setHeaders(pageFiltre);
      const res = await this._http.post(`${this.apiUri}/hypermed`, filtres, this.httpOptions).toPromise();
      const ccam = res.body as Ccam[];
      const paginated: Paginated<Ccam> = {
        page: Number(res.headers.get('x-page')),
        perpage: Number(res.headers.get('x-per-page')),
        total: Number(res.headers.get('x-total')),
        objects: ccam
      };
      return paginated;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async findOneHypermed(id: string) {
    try {
      const res = await this._http.get(`${this.apiUri}/hypermed/${id}`, this.httpOptions).toPromise();
      const ccam = res.body as Ccam;
      return ccam;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async delete(id: string) {
    try {
      const res = await this._http.delete(`${this.apiUri}/user/${id}`, this.httpOptions).toPromise();
      return;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }
}
